// extracted by mini-css-extract-plugin
export default {"video":"BackgroundVideo_video__P6rYv","cropVideo":"BackgroundVideo_cropVideo__DLX01"};